import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=c2bb7b5c&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=c2bb7b5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bb7b5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2bb7b5c')) {
      api.createRecord('c2bb7b5c', component.options)
    } else {
      api.reload('c2bb7b5c', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=c2bb7b5c&scoped=true&", function () {
      api.rerender('c2bb7b5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bVzqE6EeESP4/JS/comp/CookieBox.vue"
export default component.exports